import React from 'react'

export default function CardDataThree(props) {
  const accent = props.color || '#38bdf8'
  return (
    <div
      className="md-card md-card--triple"
      style={{ '--md-accent': accent }}
    >
      <div className="md-card__glow" aria-hidden />
      <div className="md-card__triple-top">
        <span className="md-card__eyebrow">{props.titleTop}</span>
        <span className="md-card__figure">{props.valueTop}</span>
      </div>
      <div className="md-card__triple-split">
        <div className="md-card__split-cell">
          <span className="md-card__micro">{props.titleLeft}</span>
          <span className="md-card__subfigure">{props.valueLeft}</span>
        </div>
        <div className="md-card__split-divider" />
        <div className="md-card__split-cell">
          <span className="md-card__micro">{props.titleRight}</span>
          <span className="md-card__subfigure">{props.valueRight}</span>
        </div>
      </div>
    </div>
  )
}
